let log = localStorage.getItem("aatPassiveLogger") === "true";
export const getLoggerEnabled = () => {
    return log;
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/logger/logger-store.js
// module id = ./node_modules/@celine/passive-tracking/dist/logger/logger-store.js
// module chunks = 0